module.exports = __webpack_public_path__ + "static/img/3.4faa47e2.png";